class LqdAsymSliderHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initSplitText();
    this.initSlider();

  }

  getDefaultSettings() {
    return {
      selectors: {
        splitTextElement: '[data-split-text]',
        asymSliderElement: '[data-asym-slider]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $splitTextElement: this.$element.find(selectors.splitTextElement),
      $asymSliderElement: this.$element.find(selectors.asymSliderElement),
    }
  }

  initSplitText() {

    this.elements.$splitTextElement.liquidSplitText();

  }

  initSlider() {

    this.elements.$asymSliderElement.liquidAsymmetricSlider();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdAsymSliderHandler, { $element } );
};